import React, { useCallback } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { CommandPanels, withBaseEditor } from '../../BaseEditor';
import { GeneralTP } from './tp';

function SpecialPurposeEditor({
  getControl, data, fields, dataSetter,
}) {
  const onPercentValueChange = useCallback(
    (e, newRecs) => dataSetter({ percentvalue_set: newRecs }),
    [dataSetter],
  );

  return (
    <Grid container spacing={2}>
      <Grid item sm={3}>
        {getControl('code')}
      </Grid>
      <Grid item sm={9}>
        {getControl('name')}
      </Grid>
      <Grid item sm={12}>
        <GeneralTP
          data={data.percentvalue_set}
          options={fields.percentvalue_set}
          onChange={onPercentValueChange}
        />
      </Grid>
    </Grid>
  );
}

SpecialPurposeEditor.propTypes = {
  getControl: PropTypes.func.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    percentvalue_set: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  dataSetter: PropTypes.func.isRequired,
  fields: PropTypes.shape({
    percentvalue_set: PropTypes.shape({}),
  }).isRequired,
};

export default withBaseEditor(SpecialPurposeEditor, '/api/catalog/specialpurpose/', CommandPanels.catCommandPanel);
